import logoProduction from '../assets/img/logo-web-new-removebg.svg';
import logoStaging from '../assets/img/logo_staging.png';

const environment = (process.env.REACT_APP_ENV || process.env.NODE_ENV).replace(/\s/g, '');

const isNonProductionEnvironment = environment === 'staging' || environment === 'development';

const appLogo = isNonProductionEnvironment ? logoStaging : logoProduction;

export default appLogo;
